import { GrowthBook } from '@growthbook/growthbook-react'
import axios, { AxiosError, AxiosResponse } from 'axios'
import axiosRetry from 'axios-retry'
import { useEffect, useState } from 'react'
import { emitExperimentViewedGAEvent } from '../ga-event-helpers'

axiosRetry(axios, {
	retries: 3,
	retryDelay: (retryCount) => {
		// console.log(`retry attempt: ${retryCount}`)
		return retryCount * 2000
	},
})

// experiment_viewed must fire once per (experiment, variation) per page load.
// Header — and therefore this hook — remounts on every SPA navigation, and each
// mount builds a fresh GrowthBook whose per-instance trackingCallback dedup is
// wiped. A module-level Set survives those remounts so the GA event is not
// re-emitted on every navigation (THP-101 / BHP-1632 A.8).
const emittedExperiments = new Set<string>()

export const useGrowthbook = () => {
	const experimentEndpoint = `${process.env.NEXT_PUBLIC_BACKEND_URL}/hotels/experiment?api-key=${process.env.NEXT_PUBLIC_API_KEY}`
	const [growthbook, setGrowtBookInstance] = useState<
		GrowthBook<Record<string, any>>
	>(() =>
		new GrowthBook({
			enableDevMode: process.env.NODE_ENV !== 'production',
			apiHost: 'https://cdn.growthbook.io/',
			clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_API_KEY,
			trackingCallback: (experiment, result) => {
				// console.log('Tracking callback called')

				const interval = setInterval(() => {
					if (window.dataLayer) {
						// console.log('GA, tracking callback called')
						const dedupeKey = `${experiment.key}:${result.variationId}`
						if (!emittedExperiments.has(dedupeKey)) {
							emittedExperiments.add(dedupeKey)
							emitExperimentViewedGAEvent(
								experiment.key,
								result.variationId.toString(),
								new Date().toISOString(),
							)
						}
						clearInterval(interval);
					}
				}, 2000)
				
				axios
					.post(
						experimentEndpoint,
						{
							experiment_id: experiment.key,
							variation_id: result.variationId.toString(),
							event_timestamp: new Date().toISOString(),
						},
						{
							withCredentials: true,
						}
					)
					.then((response: AxiosResponse) => {
						// console.log(JSON.stringify('experiment viewed', response.data))
					})
					.catch((error: AxiosError) => {
						console.log(error)
					})
			},
		})
	)

	useEffect(() => {
		if (growthbook) {
			growthbook.setAttributes({
				url: window.location.href,
			})
			growthbook.init()
		}
	}, [growthbook])

	const gbCallback = (params: { uid: string }) => {
		const { uid } = params

		growthbook.setAttributes({
			id: uid,
			url: window.location.href,
		})
	}
	return { growthbook, gbCallback }
}
